var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudFlare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.126207 374H346.24C354.987 361.675 364.822 333.755 334.182 320.672L141.976 318.539C133.439 318.535 133.439 310.006 141.976 310.006H334.182C351.452 305.795 387.426 285.787 394.9 239.315L394.903 239.293C395.095 238.091 395.155 236.863 395.057 235.651C388.486 153.75 225.196 70.7974 161.835 222.544C134.884 203.345 61.8309 209.748 76.0159 282.275C44.0714 282.275 -2.74704 297.204 0.126207 374Z",
    fill: "#EC7D1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M420.002 310.006H463.266C471.041 310.002 471.75 319.25 463.266 319.25L420.002 320.672C403.216 323.279 368.51 337.595 363.971 374H508.658C518.353 332.807 512.496 250.446 414.506 242.873C410.022 242.527 405.642 244.684 403.511 248.644C393.579 267.109 386.647 297.846 420.002 310.006Z",
    fill: "#F2A83D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudFlare);
export default __webpack_public_path__ + "static/media/cloud-flare.5412d62b7df2215254ed351afa480c99.svg";
export { ForwardRef as ReactComponent };